import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { company } from '../data/company';
import { commodities } from '../data/products';
import { quickOrderMailto, whatsappLink } from '../utils/contact';
export function Footer() {
  return <footer className="border-t border-hair bg-panel" data-id="element-74" data-mp="36qhf8uj4ny17">
      <div className="mx-auto max-w-shell px-6 py-16" data-id="element-75" data-mp="3uf0phflqmkvx">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]" data-id="element-76" data-mp="3ugbpd4c2b8hr">
          <div data-id="element-77" data-mp="38z9csmx113f">
            <img src={company.logo} alt={`${company.name} logo`} className="h-20 w-20 object-contain" data-id="element-78" data-mp="37ft3219eq1n" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted" data-id="element-79" data-mp="3qd6qrcv3rqye">
              A Congolese mining and trading company established in {company.established} — mining,
              sourcing and exporting precious metals, copper units, rough diamonds and coloured
              gemstones to verified buyers worldwide.
            </p>
            <div className="mt-5 flex items-center gap-3" data-id="element-80" data-mp="3labr7utqu4pu">
              {company.primaryCountries.map(country => <img key={country.name} src={country.flag} alt={`Flag of ${country.name}`} className="h-6 w-auto border border-hair object-cover" loading="lazy" data-id="element-81" data-mp="3gca6l5go5xc9" />)}
              <span className="text-xs text-muted" data-id="element-82" data-mp="81fo5rt1yk23">
                DRC · Zambia · East Africa
              </span>
            </div>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-gold" data-id="element-83" data-mp="3230x5y9rayz">
              CEO — {company.ceo}
            </p>
          </div>

          <div data-id="element-84" data-mp="cv1pwoxoh3j4">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-85" data-mp="cuik26lay5lg">
              Commodities
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-86" data-mp="mrwm316haru8">
              {commodities.map(item => <li key={item.id} data-id="element-87" data-mp="tv4om5kz9a6l">
                  <Link to="/commodities" className="text-muted transition-colors duration-150 hover:text-gold-light" data-id="element-88" data-mp="tw5w602sbejk">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-89" data-mp="18l2cekezvxv9">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-90" data-mp="18lk7hdpx861l">
              Company
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-91" data-mp="1cnyodsa14vq8">
              {[{
              to: '/about',
              label: 'About & leadership'
            }, {
              to: '/live-orders',
              label: 'Live order book'
            }, {
              to: '/commodities',
              label: 'Specifications'
            }, {
              to: '/contact',
              label: 'Trading desk'
            }].map(link => <li key={link.to} data-id="element-92" data-mp="3ocghempel95q">
                  <Link to={link.to} className="text-muted transition-colors duration-150 hover:text-gold-light" data-id="element-93" data-mp="3odhuewpzc5q3">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-94" data-mp="25mkf6t8c68et">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-95" data-mp="21mk159p5fz8a">
              Contact
            </h2>
            <ul className="mt-5 space-y-4 text-sm text-muted" data-id="element-96" data-mp="1worybkmyuspb">
              {company.offices.map(office => <li key={office.label} className="flex gap-3" data-id="element-97" data-mp="2tcokd516ag7x">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-98" data-mp="2pbuui6466rce" />
                  <span data-id="element-99" data-mp="2kcrzlehwm1i5">
                    <span className="block text-bone/90" data-id="element-100" data-mp="2kc8ig002vh56">{office.label}</span>
                    {office.lines.map(line => <span key={line} className="block" data-id="element-101" data-mp="2fdyhf8ro9mbn">
                        {line}
                      </span>)}
                  </span>
                </li>)}
              <li className="flex gap-3" data-id="element-102" data-mp="13xqgtcvswl2m">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-103" data-mp="2rv7q80hgq42d" />
                <a href={whatsappLink()} target="_blank" rel="noreferrer" className="transition-colors duration-150 hover:text-gold-light" data-id="element-104" data-mp="2wm7ob92bis6g">
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex gap-3" data-id="element-105" data-mp="3bj71dcfxvd8b">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-106" data-mp="3bk8bnep4rvoz" />
                <a href={`mailto:${company.email}`} className="transition-colors duration-150 hover:text-gold-light" data-id="element-107" data-mp="3fk0m5wy34bwz">
                  {company.email}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-108" data-mp="1q6doca5pxylf">
                <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-109" data-mp="1q5caxz18d00j" />
                <span data-id="element-110" data-mp="1v6i6e4m9z1dr">{company.hours}</span>
              </li>
            </ul>
            <a href={quickOrderMailto()} className="mt-6 inline-block rounded-sm border border-gold px-4 py-2.5 text-sm font-semibold text-gold-light transition-colors duration-150 hover:bg-gold hover:text-ink" data-id="element-111" data-mp="1nlg0vq0s80uy">
              Place an Order
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-hair pt-6 text-xs text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-112" data-mp="1rom1oi54kzu1">
          <p data-id="element-113" data-mp="13vm1oqvqmjgp">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p className="font-mono uppercase tracking-[0.16em]" data-id="element-114" data-mp="1dnrshxa96uub">
            ITSCI member · Kimberley Process · LME Grade A supply
          </p>
        </div>
      </div>
    </footer>;
}